import { render } from "./YotpoLogoIcon.vue?vue&type=template&id=5cf94563"
import script from "./YotpoLogoIcon.vue?vue&type=script&lang=js"
export * from "./YotpoLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__